import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './ConsultationSlots.css'
import headerImg from "../../../assets/images/first page components/Navbar (2).jpg";
import languageLogo from "../../../assets/images/language logo - 1.png";

const ConsultationSlots = () => {
  const navigate = useNavigate()
  
  const [showLanguageMismatch, setShowLanguageMismatch] = useState(false)
  const [selectedSlot, setSelectedSlot] = useState(null)
  const [selectedAstrologerType, setSelectedAstrologerType] = useState('')
  const [language, setLanguage] = useState('')
  const [errors, setErrors] = useState({
  language: '',
  astrologerType: '',
  slot: ''
});
  
const handleSlotSelect = (slot) => {
  if (!language) {
    setErrors(prev => ({
      ...prev,
      language: 'Before selecting a slot, Please select a Language',
    }));
    return;
  }

  setSelectedSlot(slot);
  setErrors(prev => ({ ...prev, slot: '' }));

  if (language !== 'hindi') {
    setShowLanguageMismatch(true);
  } else {
    setShowLanguageMismatch(false);
  }
};

const handleBookSlot = () => {
  const newErrors = { language: '', astrologerType: '', slot: '' };

  if (!language) {
    newErrors.language = 'Please select your language';
  }
  if (!selectedAstrologerType) {
    newErrors.astrologerType = 'Please select an astrologer type';
  }
  if (!selectedSlot) {
    newErrors.slot = 'Please select a consultation slot';
  }

  setErrors(newErrors);

  const hasError = Object.values(newErrors).some(Boolean);
  if (hasError) return;

  navigate('/consultation-success');
};

  const handleContinueDifferentLanguage = () => {
    setShowLanguageMismatch(false)
  }

  const handleChooseOtherSlot = () => {
    setShowLanguageMismatch(false)
    setSelectedSlot(null) 
  }

  const consultationSlots = [
    {
      id: 1,
      label: "1st Slot",
      time: "9:00 AM - 12:00 PM",
      date: "02 Aug 2025",
      available: true,
      slotsCount: 15,
      availableLanguages: ['hindi', 'english', 'tamil', 'telugu']
    },
    {
      id: 2,
      label: "2nd Slot",
      time: "12:00 PM - 3:00 PM",
      date: "02 Aug 2025",
      available: true,
      slotsCount: 22,
      availableLanguages: ['hindi', 'english', 'tamil', 'telugu']
    },
    {
      id: 3,
      label: "3rd Slot",
      time: "3:00 PM - 5:00 PM",
      date: "02 Aug 2025",
      available: true,
      slotsCount: 8,
      availableLanguages: ['hindi', 'english', 'tamil']
    },
    {
      id: 4,
      label: "4th Slot",
      time: "5:00 PM - 9:00 PM",
      date: "02 Aug 2025",
      available: false,
      slotsCount: 0,
      availableLanguages: []
    },
  ]
    useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="consultation-slots-page home-layout-bg">
      <img 
        src={headerImg} 
        alt="AstroCure Navbar" 
        className="navbar-image"
      />

      <main className="main-content hero-section">
        <div className="form-container">
          <h2 className="form-title">Schedule Your Free Consultation</h2>
          
          <form className="consultation-form">
             <div className="form-group">
                  <select id="language" name="language" value={language}    
                  onChange={(e) => {
                    setLanguage(e.target.value);
                    setErrors(prev => ({ ...prev, language: '' }));
                  }} required>
                    <option value="">Select your language</option>
                    <option value="hindi">Hindi</option>
                    <option value="english">English</option>
                    <option value="tamil">Tamil</option>
                    <option value="telugu">Telugu</option>
                  </select>
                  <label htmlFor="language">Language</label>
                  {errors.language && <p className="error-message">{errors.language}</p>}
              </div>
            <div className="form-group">
              <select 
                id="astrologerType" 
                value={selectedAstrologerType}
                onChange={(e) => {
                  setSelectedAstrologerType(e.target.value);
                  setErrors(prev => ({ ...prev, astrologerType: '' }));
                }}
                required
              >
                <option value="">Select astrologer type</option>
                <option value="vedic">Vedic Astrologer</option>
                <option value="tarot">Tarot</option>
              </select>
              <label htmlFor="astrologerType">Astrologer Type</label>
            </div>
              {errors.astrologerType && <p className="error-message">{errors.astrologerType}</p>}


            <div className="slots-section">
              <h3 className="slots-title">Select Consultation Slot <span className="red-asterisk">*</span></h3>
   
              
              <div className="slots-grid">
                {consultationSlots.map((slot) => (
                  <div 
                    key={slot.id} 
                    className={`slot-card ${slot.available ? 'available' : 'unavailable'} ${selectedSlot?.id === slot.id ? 'selected' : ''}`}
                    onClick={() => slot.available && handleSlotSelect(slot)}
                  >
                    <div className="slot-label">{slot.label}</div>
                    <div className="slot-status">
                      {slot.available ? (
                        <>
                          <span className="status-icon available">✅</span>
                          <span className="slots-count">{slot.slotsCount} Slots Available</span>
                        </>
                      ) : (
                        <>
                          <span className="status-icon unavailable">❌</span>
                          <span className="slots-count-unavailable">No Slots Available</span>
                        </>
                      )}
                    </div>
                    <div className="slot-time">{slot.time}</div>
                    <div className="slot-date">{slot.date}</div>
                  </div>
                ))}
                {errors.slot && <p className="error-message">{errors.slot}</p>}
              </div>
            </div>
            <button 
              type="button" 
              className="book-slot-button" 
              onClick={handleBookSlot}
            >
               <span role="img" aria-label="finger" className="book-slot-icon">👉</span>
                Book Your Slot
            </button>
            <p className="proceeding-text">
              By proceeding, you accept our
              <span
                style={{ color: "#7611AE", cursor: "pointer"}}
                onClick={() => {
                  window.open("/terms-and-conditions");
                }}
              >
               {" "} Terms & Conditions
              </span>
            </p>
          </form>
        </div>
        <div className="back-link">
          <Link to="/free-campaign-booking" className="back-btn">
            ← Back to Details
          </Link>
        </div>
      </main>

      {showLanguageMismatch && (
        <div className="language-mismatch-modal">
          <div className="modal-content">
            <div className="language-logo">
              <img 
                src={languageLogo} 
                alt="Language Logo" 
                className="logo-image-modal"
              />
            </div>
            
            <h3 className="modal-title">
              Language Mismatch 🌐
            </h3>
            
            <p className="modal-message">
              You've selected <span className="selected-language">{language.charAt(0).toUpperCase() + language.slice(1)}</span> as your preferred language, but your assigned astrologer is available only in <span className="available-language">Hindi</span> right now. Would you like to continue in <span className="available-language">Hindi</span> or choose other slot?
            </p>
            
            <div className="modal-actions">
              <button 
                className="choose-other-slot-btn"
                onClick={handleChooseOtherSlot}
              >
                Choose Other Slot
              </button>
              <button 
                className="continue-btn"
                onClick={handleContinueDifferentLanguage}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ConsultationSlots